import { GameState, Facing, GroundTile, BuildingType, TreeState } from '../types';
import { MAP_COLS, MAP_ROWS, TILE, CHOP_HITS } from '../constants';

export function createNewGame(): GameState {
  // Create ground: mostly grass, path near vendor
  const ground: GroundTile[][] = [];
  for (let r = 0; r < MAP_ROWS; r++) {
    const row: GroundTile[] = [];
    for (let c = 0; c < MAP_COLS; c++) {
      // Path tiles: row 2, cols 4-7 (vendor area)
      if (r >= 1 && r <= 3 && c >= 4 && c <= 7) {
        row.push('path');
      } else if (r >= 4 && r <= 6 && c >= 5 && c <= 6) {
        // Path connecting vendor to base area
        row.push('path');
      } else {
        row.push('grass');
      }
    }
    ground.push(row);
  }

  // Trees - 8 scattered around the map, avoiding vendor/base/path areas
  const treePositions: [number, number][] = [
    [1, 1], [1, 9], [1, 11],
    [4, 0], [4, 10],
    [7, 1], [7, 8], [8, 11],
  ];

  const trees: TreeState[] = treePositions.map(([r, c]) => ({
    gridX: c,
    gridY: r,
    hp: CHOP_HITS,
    regrowTimer: 0,
    shakeTimer: 0,
  }));

  // Vendor at center-top (col 5-6, row 2)
  const vendorX = 5;
  const vendorY = 2;

  // Upgrade station at base area (col 3, row 5)
  const stationGridX = 3;
  const stationGridY = 5;

  // Player starts at base area
  const playerX = 4 * TILE + TILE / 2;
  const playerY = 6 * TILE + TILE / 2;

  return {
    player: {
      x: playerX,
      y: playerY,
      facing: Facing.Right,
      wood: 0,
      coins: 0,
      spears: 0,
      hasSuperAxe: false,
      chopCooldown: 0,
      throwCooldown: 0,
      isChopping: false,
      chopTimer: 0,
    },
    trees,
    intruders: [],
    buildings: [],
    projectiles: [],
    particles: [],
    ground,
    baseLevel: 1,
    vendorX,
    vendorY,
    stationGridX,
    stationGridY,
    paused: false,
    buildMode: false,
    buildSelection: null,
    buildGhostX: 0,
    buildGhostY: 0,
    intruderSpawnTimer: 25,
    autoSaveTimer: 30,
    tutorialStep: 1,
    hasWon: false,
    camX: 0,
    camY: 0,
    totalTime: 0,
  };
}
